import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <section id="voices" className="relative bg-[#E6C5C0] py-24 md:py-40 z-[2]" data-testid="testimonials-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#1A1A1A]" />
              <span className="eyebrow text-[#1A1A1A]">Chapter · 03 · Voices</span>
            </div>
            <h2 className="font-serif-editorial text-5xl md:text-7xl leading-[0.95] tracking-tight text-[#1A1A1A]">
              What clients<br /><span className="italic">say after.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {items.map((t, i) => (
            <motion.blockquote
              key={t.id}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              className={`col-span-12 sm:col-span-6 lg:col-span-4 bg-[#F9F6F0] p-8 md:p-10 relative`}
              data-testid={`testimonial-${i}`}
            >
              <Quote size={20} strokeWidth={1.25} className="text-[#C5A059] mb-6" />
              <p className="font-serif-editorial text-xl md:text-2xl italic leading-snug text-[#1A1A1A] mb-8">
                “{t.quote}”
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-black/10">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-[#E6C5C0] shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-[#1A1A1A]">{t.name}</p>
                  <p className="eyebrow text-[#5C5C5C] mt-1">{t.trip} · {t.location}</p>
                </div>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
